import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { TextLanguage, TextState } from "./interfaces";

const initialState: TextState = {
  domain: null,
  isLoading: false,
  fetched: false,
  error: null,
  language: TextLanguage.NORWEGIAN_BOKMAAL,
};

const textsSlice = createSlice({
  name: "text",
  initialState,
  reducers: {
    textRequested: (state, _action: PayloadAction<string>) => {
      state.isLoading = true;
    },

    textsSucceeded: (state, action: PayloadAction<any>) => {
      const { payload } = action;
      state.domain = payload;
      state.isLoading = false;
      state.fetched = true;
    },

    textsFailed: (state, action: PayloadAction<string>) => {
      state.error = action.payload.toString();
      state.fetched = true;
      state.isLoading = false;
    },
  },
});

export const { textRequested, textsFailed, textsSucceeded } =
  textsSlice.actions;
export const texts = textsSlice.reducer;
